export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/3c07b75605a6-tooliconclock.jpg',
  },
  title: "What was the flight's scheduled departure and arrival time?",
}
